<template>
  <div>
    <button class="d-none" data-toggle="modal" data-target="#manageTourTeamSeedars"
      ref="openModalManageTourTeamSeedars"></button>
    <div class="modal fade" tabindex="-1" role="dialog" id="manageTourTeamSeedars">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title m-0">Edit Pool Seed <br/> <span>{{ tournament?.tournamentName }}</span></h6>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" ref="closeManageTourTeamSeedars">
              <img src="../../../assets/Svg/close.svg" />
            </button>
          </div>
          <div class="modal-body">

            <div class="teammates-lineup-wrapper" >
              <div class="available-teammates w-100">
                <!-- <h6>Available Seedars</h6> -->
                <div class="teammates-info">
                  <draggable class="list-group" 
                    :list="availableSeedars" 
                    group="people" 
                    handle=".handle"
                    @change="handleReorder" 
                    v-if="showLoaderAvailableParks == 0">
                    <div class="list-group-item" v-for="(element, index) in availableSeedars" :key="element.id || index">
                      <div class="shirt-no-wrapper">
                        <small>{{ index + 1 }}.</small>
                        <div class="d-flex flex-column">
                          <p class="name"><span>#{{ element?.team_sr_no }}:</span> {{ element?.team?.team_name }}</p>
                          <small class="pt-1 age-group-content text-capitalize">
                            {{ element?.team?.age_group?.name ? element?.team.age_group?.name + '-' : '' }}
                            {{ element?.team?.gender ? element.team.gender + '-' : '' }}
                            {{ element?.team?.ratings?.rate }}
                          </small>
                          <small class="pt-1 age-group-content text-capitalize">
                            {{ element?.team?.city }},
                            {{ element?.team?.state }}
                          </small>
                          <!-- <small class="pt-1 age-group-content text-capitalize" v-if="element?.seed_criteria">
                            Seed Criteria Name: {{ element?.seed_criteria?.criteria_name }}
                          </small> -->
                        </div>
                      </div>
                      <div class="handle">
                        <img src="../../../assets/images/line-ellipsis.png" alt="" />
                      </div>
                    </div>
                  </draggable>
                  <div class="no-line-up" v-if="
                    showLoaderAvailableParks == 0 &&
                    availableSeedars.length == 0
                  ">
                    <div class="img">
                      <img src="../../../assets/images/teammates.png" alt="" />
                    </div>
                    <p class="text">No available seeded team found.</p>
                  </div>
                  <div class="lds-dual-ring-media" v-if="showLoaderAvailableParks == 1"></div>
                </div>
              </div>
              
            </div>
          </div>
          <div class="event-btns-wrapper pt-3 justify-content-end">
            <button v-if="this.isDisabled == false" type="button" class="btn btn-primary" block
              @click="manageTournamentSeedars(0)" :disabled="isLoadingArray[0]">
              <div v-if="isLoadingArray[0]" class="lds-dual-ring"></div>
              <span v-else><img class="mr-1" src="../../../assets/Svg/save.svg" alt="save" />Save</span>
            </button>
            <button v-else-if="this.isDisabled == true" type="button" class="btn btn-primary-disabled"
              :disabled="isLoadingArray[0]">
              <div v-if="isLoadingArray[0]" class="lds-dual-ring"></div>
              <span v-else><img class="mr-1" src="../../../assets/Svg/save.svg" alt="save" />Save</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import draggable from "vuedraggable";

export default {
  name: "TournamentTeamSeedingModal",
  components: {
    draggable,
  },
  props: {
    association_id: {
      type: Number,
    },
  },
  data() {
    return {
      isDisabled: true,
      isLoadingArray: [],
      selectedSeedars: [],
      showLoaderSelectedParks: 1,
      availableSeedars: [],
      showLoaderAvailableParks: 1,
      localTournament: {},
      criteriaChecked: false,
      tournament: {},
      tournament_guid: '',
      originalOrder: [], // Track original order for comparison
      hasReordered: false, // Flag to track if user has reordered
    };
  },
  watch: {
    selectedSeedars: function (newValue) {
      if (newValue.length > 0 || this.availableSeedars.length > 0) {
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }
    },
    availableSeedars: function (newValue) {
      if (newValue.length > 0 || this.selectedSeedars.length > 0) {
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }
    },
  },

  methods: {
    onToggleChange(value) {
      if (!value) {
        this.selectedSeedars = []; // Clear when toggle is OFF
      }
    },
    
    closeModal() {
      const elem = this.$refs.closeManageTourTeamSeedars;
      if (elem) {
        elem.click();
      }
      // Reset reorder tracking when modal closes
      this.hasReordered = false;
      this.originalOrder = [];
    },

    // Handle drag and drop reordering
    handleReorder(evt) {
      console.log('Reorder event:', evt);
      this.hasReordered = true;

      // Update seed positions based on new order
      this.updateSeedPositions();
    },

    // Update seed positions after reordering
    updateSeedPositions() {
      this.availableSeedars = this.availableSeedars.map((item, index) => ({
        ...item,
        seed_position: index + 1, // Update seed position based on new order
        display_order: index + 1
      }));
    },

    // Prepare seeding data with proper ordering
    prepareSeedingData() {
      return this.availableSeedars.map((item, index) => ({
        team_id: item.team?.id,
        team_sr_no: item.team_sr_no,
        seed_position: index + 1,
        display_order: index + 1,
        seed_criteria_id: item.seed_criteria?.id,
      }));
    },

    async manageTournamentSeedars(index) {
      this.$set(this.isLoadingArray, index, true);
      try {


        // Prepare reordered seeding data
        const reorderedSeedingData = this.prepareSeedingData();

        // Prepare payload
        const payload = {
          tournament_id: this.tournament?.id,
          association_id: this.association_id,
          reordered_seedars: reorderedSeedingData,
          has_reordered: this.hasReordered
        };

        console.log("Seed criteria payload with reordering:", payload);

        // ✅ Only proceed with API call if reordering occurred
        if (!this.hasReordered) {
          this.$set(this.isLoadingArray, index, false);
          this.closeModal();
          return;
        }
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}tournaments/teams/updateSeedCount`,
          payload
        );

        if (response.data.statusCode === 200) {
          this.$root.$emit('fetchTournaments');
          this.closeModal();
        } else {
          throw new Error(response.data.message || 'Failed to update seeding order');
        }

      } catch (error) {
        console.error("Error saving selected Seedars:", error);
        this.errorMessage = "Failed to update seed criteria. Please try again.";
        
      } finally {
        this.$set(this.isLoadingArray, index, false);
      }
    },

    handleAvailableSeedars(evt) {
      if (evt.added) {
        this.selectedSeedars.push(evt.added.element);
      }
    },
    
    handleSelectedSeedars(evt) {
      if (evt.removed) {
        const index = this.selectedSeedars.indexOf(evt.removed.element);
        if (index > -1) {
          this.selectedSeedars.splice(index, 1);
        }
      }
    },

    async getSeedarsForAssociation() {
      try {
        this.showLoaderSelectedParks = 1;
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}tournaments/getDefaultSeedars?tournament_id=${this.tournament.id}&association_id=${this.association_id}`
        );

        if (response.data.statusCode === 200) {
          this.selectedSeedars = Object.values(response.data.data);
          this.showLoaderSelectedParks = 0;
        } else {
          this.closeModal();
          this.errorMessage = response.data.message || "Unknown error occurred";
          this.showLoaderSelectedParks = 0;
        }
      } catch (error) {
        this.errorMessage = "Failed to fetch data";
        this.showLoaderSelectedParks = 0;
      }
    },

    async getTournamentSeedars() {
      try {
        this.showLoaderAvailableParks = 1;
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}tournaments/teams/getSeededTeams?tournament_guid=${this.tournament?.guid}&association_id=${this.association_id}`
        );

        if (response.data.statusCode === 200) {
          this.availableSeedars = Object.values(response.data.data);
          
          // Store original order for comparison
          this.originalOrder = [...this.availableSeedars];
          
          // Initialize seed positions if not already set
          this.availableSeedars = this.availableSeedars.map((item, index) => ({
            ...item,
            seed_position: item.seed_position || index + 1,
            display_order: item.display_order || index + 1
          }));
          
          this.showLoaderAvailableParks = 0;
        }
        else if (response.data.statusCode === 404) {
          this.closeModal();
          this.showLoaderAvailableParks = 0;
        }
        else {
          this.closeModal();
          this.errorMessage = response.data.message || "Unknown error occurred";
          this.showLoaderAvailableParks = 0;
        }
      } catch (error) {
        this.closeModal();
        this.errorMessage = "Failed to fetch data";
        this.showLoaderAvailableParks = 0;
      }
    },
  },

  mounted() {
    this.$root.$on("openManageTourTeamsSeedarsModal", (selectedTournament) => {
      console.log("Tournament Team Seeding Modal opened for tournament:", selectedTournament);
      this.tournament = selectedTournament;
      var elem = this.$refs.openModalManageTourTeamSeedars;
      if (elem) {
        elem.click();
        this.getTournamentSeedars();
      }
    });
  },
};
</script>